
export const calculateBsrsScore = (answers: number[]): number => {
  // note: the last question is bonus, not added to score
  return answers.slice(0, 5).reduce((sum, score) => sum + score, 0);
}